export const useCurrentYear = () => {
  return new Date().getFullYear()
}
